import { useParams } from "react-router-dom";
import { EditInspectionForm } from "src/components/Forms/EditInspectionForm";

export function EditInspection() {
  const { inspectionId } = useParams();
  return <EditInspectionForm id={inspectionId || ""} />;
}
